// extracted by mini-css-extract-plugin
module.exports = {"pulse":"style_pulse__2_Gi9"};